import axios from 'axios';

export const fetchAIAlerts = async () => {
  try {
    const response = await axios.get('https://sense-agro-backend.onrender.com/api/ai-alerts');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar alertas da IA:', error);
    return [];
  }
};
